import React, { useEffect } from 'react';

import { Typography } from '@material-ui/core';
import { Trans, useTranslation } from 'react-i18next';

import { useDispatch, useSelector } from 'react-redux';

import { useHistory } from 'react-router';

import {
  resetCustomerResponse,
  updateCompanyApi,
} from '../../store/features/account/customer/customer.action';
import storeService from '../../store';
import {
  getCustomerError,
  getCustomerState,
  isCustomerApiSuccess,
} from '../../store/features/account/customer/customer.selector';
import { ErrorResponse } from '../../types/interface/error.interface';

import CompanyForm from './company-form';
import useStyle from './style';

import { EventService } from 'services';
import { Header, ScrollView, View } from 'components';
import { CustomerState } from 'store/features/account/customer/customer.state';

interface Props {
  testid?: string;
}

const Company: React.FC<Props> = ({ testid = 'test-header-company-page' }) => {
  const classes = useStyle();
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const store = storeService.getStore();
  const customer = useSelector<ReturnType<typeof store.getState>, CustomerState>(getCustomerState);
  const error = useSelector<ReturnType<typeof store.getState>, ErrorResponse>(getCustomerError);
  const apiSuccess = useSelector<ReturnType<typeof store.getState>, boolean>(isCustomerApiSuccess);

  useEffect(() => {
    if (error) {
      if ((error as any)?.error == 'Unauthorized') {
        history.push('/');
      } else {
        EventService.emit(EventService.EVENT.SHOW_NOTIFICATION, {
          showAs: 'snackbar',
          type: 'error',
          message: t('DASHBOARD_COMPANY_UNKNOWN_FAILURE'),
        });
      }
    }
    // eslint-disable-next-line
  }, [error]);

  useEffect(() => {
    if (!customer.companyName && !customer.loading) {
      history.push('/');
    }
  }, [customer]);

  useEffect(() => {
    if (apiSuccess) {
      EventService.emit(EventService.EVENT.SHOW_NOTIFICATION, {
        showAs: 'snackbar',
        type: 'success',
        message: t('DASHBOARD_COMPANY_UPDATE_SUCCESS'),
      });
      dispatch(resetCustomerResponse());
    }
    // eslint-disable-next-line
  }, [apiSuccess]);

  const companySubmit = async (values): Promise<void> => {
    dispatch(updateCompanyApi({ ...values, response: true }));
  };

  return (
    <>
      <Header
        drawerMenu={true}
        leftComponent={null}
        rightComponent={null}
        title={t('DASHBOARD_COMPANY_HEADER')}
        testId={testid}
      />
      <View>
        <Typography
          variant="body1"
          color="textSecondary"
          className={classes.headDescription}
          role={'alert'}
          tabIndex={0}
        >
          <Trans i18nKey="DASHBOARD_COMPANY_DESCRIPTION" />
        </Typography>
        <ScrollView classNames={classes.scrollView}>
          <CompanyForm companySubmit={companySubmit} customerError={error} />
        </ScrollView>
      </View>
    </>
  );
};

export default Company;
